var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _linearGradient, _linearGradient2, _clipPath, _radialGradient5, _radialGradient6, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path0, _path1, _path10, _g3, _g4, _path11, _circle, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 64,
    cy: 8.3519,
    gradientUnits: "userSpaceOnUse",
    r: 124.15
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd54f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#ffd34b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3526,
    stopColor: "#ffce3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#ffc62c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#ffba11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7785,
    stopColor: "#ffb300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb300"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 45.375,
    cy: 59.75,
    gradientUnits: "userSpaceOnUse",
    r: 52.502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d32f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4374,
    stopColor: "#ca2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#b71c1c"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 45.875,
    cy: 62.5,
    gradientUnits: "userSpaceOnUse",
    r: 47.129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef5350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e53935"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 45.5,
    cy: 66.75,
    gradientUnits: "userSpaceOnUse",
    r: 41.615
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e53935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4072,
    stopColor: "#dc3431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c62828"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 46.024,
    x2: 46.024,
    y1: 109.67,
    y2: 116.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0042918,
    stopColor: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2153,
    stopColor: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5502,
    stopColor: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9652,
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757575"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 46.024,
    x2: 46.024,
    y1: 114.42,
    y2: 120.91
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0042918,
    stopColor: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3969,
    stopColor: "#bababa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7025,
    stopColor: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9786,
    stopColor: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e9e9e"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120 116h-4v-60h4l-56-48-56 48h4v66h8v2h104v-4c0-2.21-1.79-4-4-4z"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 63.5,
    cy: 3.75,
    gradientUnits: "userSpaceOnUse",
    r: 67.639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ee3f35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8027,
    stopColor: "#dc3531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9957,
    stopColor: "#d32f2f"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 22.04,
    cy: 105.13,
    gradientTransform: "matrix(0 1 -1.1617 0 144.17 83.095)",
    gradientUnits: "userSpaceOnUse",
    r: 24.298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ccc65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2538,
    stopColor: "#96c760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5994,
    stopColor: "#84b851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#689f38"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m64 8-56 48h4v66h104v-66h4z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m64 11.95 49.48 42.41c-.3.48-.48 1.04-.48 1.64v63h-98v-63c0-.6-.18-1.16-.48-1.63zm0-3.95-56 48h4v66h104v-66h4z",
    fill: "#424242",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m124 124h-104v-8h100c2.21 0 4 1.79 4 4z",
    fill: "#689f38"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#424242"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120 119c.55 0 1 .45 1 1v1h-98v-2zm0-3h-100v8h104v-4c0-2.21-1.79-4-4-4z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73 30c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2h-18c-1.1 0-2-.9-2-2v-18c0-1.1.9-2 2-2zm0-2h-18c-2.21 0-4 1.79-4 4v18c0 2.21 1.79 4 4 4h18c2.21 0 4-1.79 4-4v-18c0-2.21-1.79-4-4-4z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98 64c1.1 0 2 .9 2 2v28c0 1.1-.9 2-2 2h-18c-1.1 0-2-.9-2-2v-28c0-1.1.9-2 2-2zm0-2h-18c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h18c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4z",
    opacity: 0.2
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m64 112h-36v-50c0-1.1.9-2 2-2h32c1.1 0 2 .9 2 2z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m60 109.57h-28c-.55 0-1-.45-1-1v-45.14c0-.55.45-1 1-1h28c.55 0 1 .45 1 1v45.14c0 .55-.45 1-1 1z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m54.5 31.5h19v19h-19z",
    fill: "#4fc3f7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m53 32v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-18c0-1.1-.9-2-2-2h-18c-1.1 0-2 .9-2 2zm20 8h-8v-8h8zm-10-8v8h-8v-8zm-8 10h8v8h-8zm10 8v-8h8v8z",
    fill: "#eee"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m79.03 65.5h19.94v29h-19.94z",
    fill: "#4fc3f7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57 82h-22c-.55 0-1-.45-1-1v-14c0-.55.45-1 1-1h22c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 106h-22c-.55 0-1-.45-1-1v-18c0-.55.45-1 1-1h22c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m68.02 115.32h-44v-3.66c0-1.37 1.11-2.48 2.48-2.48h39.05c1.37 0 2.48 1.11 2.48 2.48v3.66z",
    fill: "url(#e)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m65.55 110.18c.81 0 1.48.66 1.48 1.48v2.66h-42v-2.66c0-.81.66-1.48 1.48-1.48zm0-1h-39.05c-1.37 0-2.48 1.11-2.48 2.48v3.66h44v-3.66c0-1.37-1.11-2.48-2.47-2.48z",
    fill: "#263238",
    opacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m72.02 121.02h-52v-4.2c0-1.44 1.17-2.61 2.61-2.61h46.78c1.44 0 2.61 1.17 2.61 2.61z",
    fill: "url(#f)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m69.41 115.21c.89 0 1.61.72 1.61 1.61v3.2h-50v-3.2c0-.89.72-1.61 1.61-1.61zm0-1h-46.78c-1.44 0-2.61 1.17-2.61 2.61v4.2h52v-4.2c0-1.44-1.16-2.61-2.61-2.61z",
    fill: "#263238",
    opacity: 0.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#424242"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.76,
    cy: 111.33,
    opacity: 0.2,
    rx: 0.43,
    ry: 0.85,
    transform: "matrix(.3918 -.92 .92 .3918 -75.82 107.97)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.84,
    cy: 113.21,
    opacity: 0.2,
    rx: 0.38,
    ry: 0.7,
    transform: "matrix(.6303 -.7763 .7763 .6303 -64.655 90.633)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.3,
    cy: 112.81,
    opacity: 0.08,
    rx: 1.03,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.18,
    cy: 112.74,
    opacity: 0.08,
    rx: 1.03,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.05,
    cy: 111.47,
    opacity: 0.08,
    rx: 0.71,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.6,
    cy: 111.64,
    opacity: 0.08,
    rx: 1.02,
    ry: 0.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.14,
    cy: 111.31,
    opacity: 0.08,
    rx: 0.71,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.48,
    cy: 111.95,
    opacity: 0.08,
    rx: 1.16,
    ry: 0.56,
    transform: "matrix(.9888 -.149 .149 .9888 -16.008 10.263)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.76,
    cy: 112.69,
    opacity: 0.2,
    rx: 1.12,
    ry: 0.56,
    transform: "matrix(.9735 -.2286 .2286 .9735 -24.652 12.528)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.01,
    cy: 111.31,
    opacity: 0.2,
    rx: 1.42,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.51,
    cy: 111.06,
    opacity: 0.2,
    rx: 0.86,
    ry: 0.38,
    transform: "matrix(.835 -.5503 .5503 .835 -53.108 45.017)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.08,
    cy: 112.65,
    opacity: 0.2,
    rx: 0.58,
    ry: 1.48,
    transform: "matrix(.4194 -.9078 .9078 .4194 -72.6 111.78)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#424242"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.68,
    cy: 116.86,
    opacity: 0.2,
    rx: 0.93,
    ry: 0.43,
    transform: "matrix(.9398 -.3418 .3418 .9398 -36.048 29.147)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.63,
    cy: 118.73,
    opacity: 0.2,
    rx: 0.75,
    ry: 0.39,
    transform: "matrix(.8261 -.5635 .5635 .8261 -59.319 45.232)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.88,
    cy: 118.33,
    opacity: 0.08,
    rx: 1.14,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.08,
    cy: 118.27,
    opacity: 0.08,
    rx: 1.14,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.43,
    cy: 117,
    opacity: 0.08,
    rx: 0.78,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.7,
    cy: 117.17,
    opacity: 0.08,
    rx: 1.12,
    ry: 0.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.67,
    cy: 116.84,
    opacity: 0.08,
    rx: 0.78,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.24,
    cy: 117.48,
    opacity: 0.08,
    rx: 0.56,
    ry: 1.27,
    transform: "matrix(.1284 -.9917 .9917 .1284 -76.209 148.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.89,
    cy: 118.22,
    opacity: 0.2,
    rx: 0.56,
    ry: 1.23,
    transform: "matrix(.1969 -.9804 .9804 .1969 -62.183 160.52)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.06,
    cy: 116.84,
    opacity: 0.2,
    rx: 1.56,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.44,
    cy: 116.59,
    opacity: 0.2,
    rx: 0.39,
    ry: 0.92,
    transform: "matrix(.4963 -.8682 .8682 .4963 -71.272 110.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.6,
    cy: 118.17,
    opacity: 0.2,
    rx: 1.6,
    ry: 0.59,
    transform: "matrix(.9268 -.3757 .3757 .9268 -40.246 29.918)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m80 64c-1.1 0-2 .9-2 2v28c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-28c0-1.1-.9-2-2-2zm10 2h8v8h-8zm-10 0h8v8h-8zm0 10h8v8h-8zm8 18h-8v-8h8zm10 0h-8v-8h8zm-8-10v-8h8v8z",
    fill: "#eee"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.73,
    cy: 85,
    fill: "#ffc107",
    r: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m56.73 82c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z",
    fill: "#c62828"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m101 100h-24c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h24c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2z",
    fill: "#795548"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m101 94v4h-24v-4zm0-2h-24c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2z",
    fill: "#424242",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#g)",
    d: "m64 8-56 48h4v60h104v-60h4z",
    fill: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m122.28 53.2-55.08-48c-1.84-1.6-4.56-1.6-6.4 0l-55.08 48c-2.06 1.8-2.3 4.95-.53 7.05s4.87 2.34 6.93.54l49.91-43.49c1.13-.98 2.81-.98 3.94 0l49.91 43.49c.93.81 2.07 1.2 3.2 1.2 1.39 0 2.76-.59 3.74-1.75 1.76-2.08 1.52-5.24-.54-7.04z",
    fill: "url(#h)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m6.37 123c-.66 0-1.02-.7-1.14-1-.37-.89-.33-2.2.45-2.98.32-.32.35-.86.14-1.25-.48-.85-.68-1.91-.57-2.98.33-3.34 2.93-6.1 6.33-6.72.47-.08.94-.13 1.41-.13.62 0 1.25.08 1.86.23.08.02.16.03.24.03.34 0 .66-.17.85-.47 1.44-2.31 3.91-3.69 6.62-3.69 3.44 0 6.52 2.31 7.48 5.61.13.43.52.72.96.72.06 0 .12-.01.19-.02.49-.09.98-.14 1.46-.14.61 0 1.22.07 1.82.22 3.25.79 5.7 3.66 5.96 6.96.16 2.07-.48 4.04-1.79 5.61z",
    fill: "url(#i)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m22.56 105.03c3 0 5.68 2.01 6.52 4.89.25.87 1.05 1.44 1.92 1.44.12 0 .25-.01.37-.04.42-.08.85-.12 1.27-.12.53 0 1.06.06 1.58.19 2.84.69 4.98 3.19 5.2 6.07.13 1.65-.33 3.23-1.28 4.53l-31.72.01c-.07-.04-.31-.33-.39-.87-.07-.44 0-1.05.36-1.42.5-.49.87-1.43.3-2.45-.38-.67-.54-1.52-.45-2.4.28-2.85 2.6-5.3 5.51-5.83.41-.07.82-.11 1.23-.11.54 0 1.09.07 1.62.2.16.04.32.06.48.06.68 0 1.33-.35 1.7-.94 1.25-2 3.41-3.21 5.78-3.21m0-2c-3.16 0-5.92 1.66-7.47 4.16-.67-.16-1.37-.25-2.1-.25-.52 0-1.05.05-1.59.14-3.76.68-6.77 3.8-7.15 7.6-.22 2.23.74 3.61.72 3.63-1.87 1.88-.84 5.69 1.4 5.69h32.71c1.61-1.73 2.54-4.1 2.34-6.68-.29-3.77-3.04-6.96-6.72-7.86-.7-.17-1.39-.25-2.05-.25-.56 0-1.11.06-1.65.16-1.07-3.66-4.44-6.34-8.44-6.34z",
    fill: "#689f38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m13.91 112.93s-.08-2.41 1.86-4.99",
    style: {
      fill: "none",
      stroke: "#689f38",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.85 110.37c-2.28.04-4.5 1.83-4.84 4.01",
    style: {
      fill: "none",
      stroke: "#689f38",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.51 115.39c-2-.91-4.69-.77-6.76.29",
    style: {
      fill: "none",
      stroke: "#689f38",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m64 7c.32 0 .79.08 1.23.47l55.08 48c.83.73.93 2.01.21 2.86-.5.59-1.12.68-1.44.68s-.79-.08-1.23-.47l-49.91-43.5c-1.09-.95-2.49-1.48-3.94-1.48s-2.85.52-3.94 1.48l-49.91 43.49c-.44.39-.91.47-1.23.47s-.94-.09-1.44-.68c-.72-.85-.62-2.13.21-2.86l55.08-48c.44-.38.91-.46 1.23-.46m0-3c-1.14 0-2.28.4-3.2 1.2l-55.08 48c-2.06 1.8-2.3 4.95-.53 7.05.97 1.16 2.34 1.75 3.73 1.75 1.13 0 2.27-.4 3.2-1.2l49.91-43.5c.56-.49 1.27-.74 1.97-.74s1.41.25 1.97.74l49.91 43.49c.93.81 2.07 1.2 3.2 1.2 1.39 0 2.76-.59 3.74-1.75 1.77-2.1 1.53-5.25-.53-7.05l-55.09-47.99c-.92-.8-2.06-1.2-3.2-1.2z",
    fill: "#424242",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.883bc8efae689e7a03f8ae596a93001b.svg";
export { ForwardRef as ReactComponent };